"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_aim_1 = require("react-aim");
var CategoryItem2List_1 = __importDefault(require("./CategoryItem2List"));
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
// @ts-ignore
var CategoryItem1 = /** @class */ (function (_super) {
    __extends(CategoryItem1, _super);
    function CategoryItem1(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { over: false };
        return _this;
    }
    CategoryItem1.prototype.onClick = function () {
        var _a = this.props.productCategory, name = _a.name, displayCategoryId = _a.displayCategoryId;
        if (!this.props.disableMarketplaceBanner) {
            window.location.href = appConfig.marketplaceWebHost + "/" + appConfig.langCode + "/s/item/?rf=1108&fc=%7C" + displayCategoryId + "&k=";
        }
        else if (util_1.AppConfigService.shouldShowMarketplaceTopBanner()) {
            window.location.href = appConfig.searchWebHost + "/" + appConfig.langCode + "/s/item/?rf=1108&fc=%7C" + displayCategoryId + "&k=";
        }
        else {
            window.location.href = appConfig.searchWebHost + "/" + appConfig.langCode + "/c/1/" + encodeURIComponent(name) + "/" + displayCategoryId + "/index.html";
        }
    };
    CategoryItem1.prototype.render = function () {
        var _a = this.props.productCategory, name = _a.name, displayCategoryId = _a.displayCategoryId, itemCount = _a.itemCount;
        var over = this.state.over;
        var nameStyle = {};
        var layer2 = undefined;
        if (over) {
            layer2 = (react_1.default.createElement(CategoryItem2List_1.default, { productCategory: this.props.productCategory, disableMarketplaceBanner: this.props.disableMarketplaceBanner }));
            nameStyle = { color: '#007ca0' };
        }
        var imageUrl = "/common/images/category/" + displayCategoryId + ".png";
        imageUrl = util_1.AppService.staticUrl(imageUrl);
        return (react_1.default.createElement("div", { className: "categoryItemContainer" },
            react_1.default.createElement("a", { className: "categoryItem" },
                react_1.default.createElement("img", { src: imageUrl }),
                react_1.default.createElement("p", { className: "name", onClick: this.onClick.bind(this) },
                    react_1.default.createElement("span", { style: nameStyle }, name),
                    itemCount && react_1.default.createElement("span", { className: "number" },
                        "(",
                        itemCount.toLocaleString('en'),
                        ")")),
                react_1.default.createElement("i", { className: "fa fa-chevron-right", "aria-hidden": "true" })),
            layer2));
    };
    CategoryItem1.propTypes = {
        productCategory: prop_types_1.default.shape({
            name: prop_types_1.default.string.isRequired,
            displayCategoryId: prop_types_1.default.number.isRequired,
            itemCount: prop_types_1.default.number.isRequired,
            disableMarketplaceBanner: prop_types_1.default.bool,
        }).isRequired,
    };
    CategoryItem1 = __decorate([
        react_aim_1.source({
            mouseEnter: function (props, component) {
                // @ts-ignore
                return component.setState({ over: true });
            },
            mouseLeave: function (props, component) {
                // @ts-ignore
                return component.setState({ over: false });
            },
        }),
        __metadata("design:paramtypes", [Object])
    ], CategoryItem1);
    return CategoryItem1;
}(react_1.default.Component));
exports.default = CategoryItem1;
